import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";
import { IAddIframePayload } from "@app/dashboard/types/innerLayout/iframes/add-iframe";

export const addIframe = (payload: IAddIframePayload) => {
  return axiosPrivate.post(`/dashboard/api/v1/iframes`, payload);
};